import React from 'react';
import SyllabusManagementPage from './SyllabusManagementComponents/SyllabusManagementPage';

const SyllabusManagementContainer = (props) => {
  return <SyllabusManagementPage {...props} />;
};

export default SyllabusManagementContainer;
